<script setup>
import { categories } from "@/data/categories";
</script>

<template>
  <footer class="app-footer">
    <div class="pc-container app-footer__inner">
      <div class="app-footer__brand">
        <span class="app-footer__logo">
          Productos Chidos
        </span>

        <p>
          Cosas chidas para los peques,
          a precios que te hacen sonreír.
        </p>
      </div>

      <nav class="app-footer__col">
        <h4>Categorías</h4>

        <router-link
          v-for="category in categories"
          :key="category.slug"
          :to="`/categoria/${category.slug}`"
        >
          {{ category.label }}
        </router-link>
      </nav>

      <div class="app-footer__col">
        <h4>Ayuda</h4>

        <a href="#envios">Envíos</a>
        <a href="#cambios">
          Cambios y devoluciones
        </a>
        <a href="#mayoreo">
          Compras por mayoreo
        </a>
      </div>
    </div>

    <p class="app-footer__legal">
      © {{ new Date().getFullYear() }}
      Productos Chidos. Todos los derechos
      reservados.
    </p>
  </footer>
</template>
